module.exports = __webpack_public_path__ + "static/img/12306.faba5db0.png";